import { Component, OnInit } from '@angular/core';
import { APP_CONFIG } from '@core-app/app.config';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';

interface HomeHeroBannerThemeConfig {
    theme?: {
        homeHeroBannerHeight?: unknown;
    };
}

@Component({
    selector: 'core-block-home-hero-banner-v2',
    templateUrl: './block-home-hero-banner-v2.component.html',
    styleUrl: './block-home-hero-banner-v2.component.scss',
    standalone: false,
})
export class BlockHomeHeroBannerV2Component extends BlockAbstractComponent implements OnInit {
    hasHeading!: boolean;

    override ngOnInit() {
        super.ngOnInit();

        this.hasHeading = this.block.data.heading || this.block.data.headingTop || this.block.data.headingBottom;
    }

    getBackground() {
        const layers = [];

        if (this.block.data.bgFillColor === 'gradient' && this.block.data.bgLinearGradient) {
            layers.push(`linear-gradient(${this.block.data.bgLinearGradient})`);
        }

        if (this.block.data.useBgImage && this.block.data.image) {
            layers.push(`url(${this.block.data.image})`);
        }

        return layers.length > 0 ? layers.join(', ') : 'none';
    }

    getBackgroundColor() {
        switch (this.block.data.bgFillColor) {
            case 'white':
                return 'white';

            case 'primary':
                return 'var(--color-primary)';

            case 'secondary':
                return 'var(--color-secondary)';

            case 'secondary-2':
                return 'var(--color-secondary-2)';

            case 'gradient':
                return 'transparent';

            default:
                return this.block.data.bgFillColor || 'var(--color-primary)';
        }
    }

    get homeHeroBannerHeight(): string | null {
        const height = (APP_CONFIG as unknown as HomeHeroBannerThemeConfig).theme?.homeHeroBannerHeight;

        return typeof height === 'string' && height.trim() ? height : null;
    }
}
